export default __webpack_public_path__ + "static/media/Ballroll_00035.c77122b3.png";